import { Injectable } from '@angular/core';
import { MonPromptService, PromptOptions } from '@monsido/angular-shared-components';

import { COMMON_DIALOG_PARENT_SELECTOR } from './dialog-parent-selector.constant';

/**
 * Defaults the prompt container to the common dialog wrapper (inside the MFE shadow root),
 * so prompts opened without an explicit parentSelector are still styled.
 */
@Injectable()
export class ShadowAwareMonPromptService extends MonPromptService {
    override openPrompt (options: PromptOptions): void {
        super.openPrompt({ parentSelector: COMMON_DIALOG_PARENT_SELECTOR, ...options });
    }
}
